export const PaysI18n = {
  zh: {
    'pays-title-1': '帮我付款',
    'pays-title-2': '帮好友付款',
    'pays-name-1': '代付金额',
    'pays-name-2': '支付方式',
    'pays-tips-1': '将代付请求发给好友，即可让TA帮你买单！',
    'pays-btn-1': '发起代付请求',
    'pays-btn-2': '帮TA支付',
    'pays-detail-1': '订单详情',
    'pays-time': '剩余支付时间',
    'pays-fail': '订单已失效',
    'pays-end': '已完成支付',
    'pays-type-1': '微信',
    'pays-type-2': '支付宝',
    'pays-qr-1': '打开手机微信扫码付款',
    'pays-qr-2': '打开手机支付宝扫码付款',
    'pays-duration': '年',
    'alipay-status-pc': '支付中',
    'pays-open': '请使用 “链上会” App打开',
    'pays-wx-tip': '请点击右上角“更多"按钮，选择“在浏览器中打开”'
  },
  en: {
    'pays-title-1': 'Help me pay',
    'pays-title-2': 'Pay for your friend',
    'pays-name-1': 'Payment amount',
    'pays-name-2': 'Pay type',
    'pays-tips-1':
      'Send the payment request to a friend and let him/her pay for you!',
    'pays-btn-1': 'Initiate a payment request',
    'pays-btn-2': 'Pay him/her',
    'pays-detail-1': 'Order details',
    'pays-time': 'Remaining payment time',
    'pays-fail': 'Order has expired',
    'pays-end': 'Completed',
    'pays-type-1': 'WeChat',
    'pays-type-2': 'Alipay',
    'pays-qr-1': 'Open mobile WeChat scan code to pay',
    'pays-qr-2': 'Open mobile Alipay scan code to pay',
    'pays-duration': 'years',
    'alipay-status-pc': 'Paying',
    'pays-open': 'Please use the “ChainPal” app to open',
    'pays-wx-tip': 'Please click "more" button,  Choose open in browser!'
  }
}
